import React from 'react';
import PropTypes from 'prop-types';

import FieldError from '../FieldError';
import Asterisk from '../Asterisk';

// const radioOptions = [
//   'Yes', 'No', 'Maybe'
// ]

const RadioInput = ({
  required,
  label,
  name,
  values,
  errors,
  touched,
  className = '',
  labelClassName = '',
  inputClassName = '',
  disabled = false,
  readOnly = false,
  onChange = () => { },
  onBlur = () => { },
  radioOptions = [],
  radioLabels = [],
  popover = null,
  inline = false,
  labelWidth = 6,
  inputWidth = 6,
  dataPrivate = true,
  labelDescription,
}) => {
  let containerClassName = `form-group col-12 mb-0 rounded ${className}`;
  if (!disabled && !readOnly && errors[name] && touched[name]) {
    containerClassName += ' has-danger';
  }
  if (readOnly) {
    containerClassName += ' bg-light-hover';
  }
  if (inline) {
    containerClassName += ' row';
  }

  return (
    <div className={containerClassName}>
      <label className={`form-label ${inline ? `col-12 col-sm-${labelWidth}` : ''} ${labelClassName}`} htmlFor={name}>
        {label}{readOnly && ':'}{required && !readOnly && <Asterisk />}{popover}
      </label>
      {labelDescription && <div className='form-text'>{labelDescription}</div>}
      <div className={`${inline ? `col-12 col-sm-${inputWidth}` : ''}`} data-private={dataPrivate}>
        {readOnly
          ? <span>{values[name]}</span>
          : (
            <div className='pt-1'>
              {radioOptions.map((d, i) => (
                <div key={i} className={`form-check ${inline ? 'form-check-inline' : ''}`}>
                  <input
                    id={`${name}-${i}`}
                    className={`form-check-input pointer ${inputClassName}`}
                    type='radio'
                    name={name}
                    disabled={disabled}
                    aria-label={name}
                    onChange={onChange}
                    onBlur={onBlur}
                    checked={values[name] === d}
                    value={d} />
                  <label htmlFor={`${name}-${i}`} className='form-check-label pointer'>{radioLabels?.[i] ? radioLabels[i] : d}</label>

                </div>
              ))}
              <FieldError error={errors[name]} touched={touched[name]} disabled={disabled} />
            </div>
          )
        }
      </div>
    </div>
  );
};

RadioInput.propTypes = {
  required: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  radioOptions: PropTypes.array,
  description: PropTypes.string,
  dataCy: PropTypes.string,
  labelDescription: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.string,
  ]),
  radioLabels: PropTypes.arrayOf(PropTypes.any),
  inline: PropTypes.bool,
  labelWidth: PropTypes.number,
  inputWidth: PropTypes.number,
  popover: PropTypes.any,
  dataPrivate: PropTypes.bool,
};

export default RadioInput;
